import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Checkbox from "../../../../FormElement/Checkbox";
import { COMMON_LANGUAGES } from "../../types";

import "./styles.scss";

interface ICustomLanguagesModalProps {
  languages: string[];
  changeLanguages: (languages: string[]) => void;
  handleClose: () => void;
}

export const CustomLanguagesModal = (props: ICustomLanguagesModalProps) => {
  const { languages, changeLanguages, handleClose } = props;
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`hookForm.languageSelect.customLanguagesSelect.modal.${key}`);
  const getLanguageName = (code: string) => _t(`common.language.${code}`, code);

  const [temporarySelectedLanguages, setTemporarySelectedLanguages] =
    useState<string[]>(languages);

  const handleCheck = (code: string) => {
    setTemporarySelectedLanguages((prev) => {
      if (prev.includes(code)) {
        return prev.filter((c) => c !== code);
      }
      return [...prev, code];
    });
  };

  const handleSubmit = () => {
    changeLanguages(temporarySelectedLanguages);
    handleClose();
  };

  const handleClearSelected = () => {
    setTemporarySelectedLanguages([]);
  };

  const handleSelectAll = () => {
    setTemporarySelectedLanguages([...COMMON_LANGUAGES]);
  };

  return (
    <div className="modal modal-default custom-languages-modal">
      <div className="modal-mains">
        <button type="button" className="btn-close" onClick={handleClose} />
        <div className="custom-languages-modal-title">{t("title")}</div>
        <div className="custom-languages-modal-controls">
          <button
            type="button"
            className="btn btn-border btn-border-red"
            onClick={handleClearSelected}
          >
            {t("clear_selected")}
          </button>
          <button
            type="button"
            className="btn btn-border"
            onClick={handleSelectAll}
          >
            {t("select_all")}
          </button>
        </div>
        <div className="custom-languages-modal-list modal-mains__body">
          {COMMON_LANGUAGES.map((code) => (
            <div key={code}>
              <Checkbox
                id={`custom-language-${code}`}
                checked={temporarySelectedLanguages.includes(code)}
                onChange={() => handleCheck(code)}
                label={getLanguageName(code)}
                labelClassName="custom-languages-modal-item"
              />
            </div>
          ))}
        </div>
        <div className="custom-languages-modal-buttons">
          <button
            type="button"
            className="btn btn-border"
            onClick={handleClose}
          >
            {t("cancel")}
          </button>
          <button type="button" className="btn btn-blue" onClick={handleSubmit}>
            {t("submit")}
          </button>
        </div>
      </div>
    </div>
  );
};
